export default async function (ctx) {
  let data = {}
  let statusCode = 200
  const url = decodeURIComponent(ctx.route.path)
  const host = process.server ? ctx.req.headers.host : window.location.host

  try {
    let result = await ctx.$repositories.content.byUrl(url)
    data = result.data
    statusCode = result.status
  } catch (error) {
    console.error(error)
    return ctx.error({
      statusCode: 500,
      message: 'Something went wrong'
    })
  }

  // Handle redirects
  if (statusCode >= 300 && statusCode < 400) {
    let redirectUrl = data.result?.url.replace("/produkt/produkt", "/produkt");
    if (typeof redirectUrl !== 'undefined' && redirectUrl.length) {
      ctx.redirect(statusCode, redirectUrl)
    } else {
      const redirect = data.result?.redirectUrl || ''
      ctx.redirect(statusCode, redirect)
    }
    return ctx
  }

  // 403 means that the content is restricted
  if (statusCode === 403) {
    let hasUser = data.result?.accessRestrictions?.isLoggedIn
    let redirectUrl = '/'

    if (hasUser) {
      redirectUrl = data.result?.accessRestrictions?.noAccessPage
    } else {
      redirectUrl = data.result?.accessRestrictions?.loginPage
    }

    ctx.redirect(302, redirectUrl)
    return ctx
  }

  if (statusCode >= 400) {
    ctx.error({ statusCode: statusCode })
  }

  const page = data?.result
  const spotContent = page?.body?.spotContent
  const navigation = page?.navigation
  const content = page?.body?.content
  const social = page?.body?.social
  const meta = page?.meta
  const seo = page?.body?.sEO

  // Redirect to login if assortments is set, user is not logged in, and page is ContentProductList or brandPage
  const hasAssortments = ctx.query.assortments && ctx.query.assortments.length > 0
  const isProductListPage = meta?.type === 'ContentProductList'
  const isBrandPage = meta?.type === 'brandPage'
  const isLoggedIn = ctx.store.getters['user/user/isLoggedIn']

  if (hasAssortments && (isProductListPage || isBrandPage) && !isLoggedIn) {
    const loginPageUrl = ctx.store.getters['site/getSiteSettings']?.loginLink?.url || '/login'
    const returnUrl = ctx.route.fullPath
    ctx.redirect(302, `${loginPageUrl}?returnUrl=${encodeURIComponent(returnUrl)}`)
    return ctx
  }

  // Set current culture from content repsonse
  const currentCulture = data.context && data.context.culture ? data.context.culture : 'da-DK'

  if (ctx.store.getters['site/getCurrentCulture'] !== currentCulture) {
    ctx.store.commit('site/setCurrentCulture', currentCulture)
  }

  const payload = {
    seo,
    spotContent,
    navigation,
    content,
    meta,
    social,
    host
  }

  ctx.store.commit('content/content/setContent', payload)
  ctx.store.commit('content/content/setPageUid', meta?.id)
  ctx.store.commit('content/content/setPageId', page?.nodeid)
  ctx.payload = payload

  return ctx
}
